import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SharedModule } from '../../shared.module';
import { CoreModule } from '../../core/core.module';
import { NativeUploadBatchValidationMetaComponent } from './native-upload-batch-validation-meta/native-upload-batch-validation-meta.component';
import { CaseRoutingModule } from './case-routing.module';
import { CaseContactsComponent } from './contacts/case-contacts/case-contacts.component';
import { CaseDetailsComponent } from './case-details/case-details.component';
import { CaseSelectComponent } from './case-select/case-select.component';
import { CaseDetailsEditComponent } from './case-details-edit/case-details-edit.component';
import { CaseContactEditComponent } from './contacts/case-contact-edit/case-contact-edit.component';
import { CaseContactCreateComponent } from './contacts/case-contact-create/case-contact-create.component';
import { DownloadBriefcaseComponent } from './download-briefcase/download-briefcase.component';
import { EditBriefcaseComponent } from './download-briefcase/edit-briefcase/edit-briefcase.component';
import { DownloadBriefcaseDialogComponent } from './download-briefcase/download-briefcase-dialog/download-briefcase-dialog.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { UploadsComponent } from './uploads/uploads.component';
import { EditUploadComponent } from './uploads/edit-upload/edit-upload.component';
import { MatSortModule } from '@angular/material/sort';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NativeUploadBatchReportComponent } from './uploads/native-upload-batch-report/native-upload-batch-report.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ProductionUploadBatchReportComponent } from './uploads/production-upload-batch-report/production-upload-batch-report.component';
import { UploadFolderDialogComponent } from '@dialogs/upload-folder-dialog/upload-folder-dialog.component';
import { DatMetadataMappingComponent } from './uploads/dat-metadata-mapping/dat-metadata-mapping.component';
import { LastRunReviewDialogComponent } from './uploads/dat-metadata-mapping/last-run-review-dialog/last-run-review-dialog.component';
import { MarkdownToSafeHtmlPipe } from '../../pipes/markdown-to-safe-html.pipe';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        CaseRoutingModule,
        CoreModule,
        ReactiveFormsModule,
        MatInputModule,
        MatSelectModule,
        MatFormFieldModule,
        MatRadioModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatAutocompleteModule,
        ClipboardModule,
        MatSortModule,
        ScrollingModule,
        NgxChartsModule,
        MarkdownToSafeHtmlPipe
    ],
	declarations: [
		DatMetadataMappingComponent,
		NativeUploadBatchValidationMetaComponent,
		CaseContactsComponent,
		CaseDetailsComponent,
		CaseSelectComponent,
		CaseDetailsEditComponent,
		CaseContactEditComponent,
		CaseContactCreateComponent,
		DownloadBriefcaseComponent,
		EditBriefcaseComponent,
		DownloadBriefcaseDialogComponent,
		UploadsComponent,
		EditUploadComponent,
		NativeUploadBatchReportComponent,
		ProductionUploadBatchReportComponent,
		UploadFolderDialogComponent,
		LastRunReviewDialogComponent
	],
	exports: [
		CaseDetailsComponent,
		CaseSelectComponent,
		CaseDetailsEditComponent
	]
})

export class CaseModule {
}
